import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subscription, interval } from 'rxjs';
import { AssignedProfilesRepoService } from '@client/app/services/api/page-performance/assigned-profile-repo/assigned-profiles-repo.service';
import { contextTokens } from '@monsido/services/request-auxiliary/request-auxiliary.service';
import {
    PagePerformanceAssignedProfile,
} from '@client/app/models/page-performance/assigned-profile/assigned-profile.model';

@Injectable({
    providedIn: 'root',
})
export class AssignedProfilesObsService implements OnDestroy {
    assignedProfilesCount = 0;
    private assignedProfilesObs = new BehaviorSubject<PagePerformanceAssignedProfile[]>([]);
    private intervalSubscription: Subscription | null = null;
    private readonly INTERVAL_TIME = 300000; // 5 minutes

    constructor (
        private assignedProfilesRepoService: AssignedProfilesRepoService,
    ) {}

    ngOnDestroy (): void {
        this.disposeAssignedProfiles();
    }

    getAssignedProfilesObs (): Observable<PagePerformanceAssignedProfile[]> {
        return this.assignedProfilesObs.asObservable();
    }

    startLiveReload (): void {
        this.disposeAssignedProfiles();
        this.setupWatchers();
    }

    disposeAssignedProfiles (): void {
        if (this.intervalSubscription) {
            this.intervalSubscription.unsubscribe();
            this.intervalSubscription = null;
        }
        this.setAssignedProfiles([]);
    }

    reloadAssignedProfiles (): Promise<void> {
        return this.getAssignedProfiles()
            .then(profiles => this.setAssignedProfiles(profiles));
    }

    private setAssignedProfiles (assignedProfiles: PagePerformanceAssignedProfile[]): void {
        this.assignedProfilesCount = Array.isArray(assignedProfiles) ? assignedProfiles.length : 0;
        this.assignedProfilesObs.next(assignedProfiles);
    }

    private setupWatchers (): void {
        this.getAssignedProfiles()
            .then(profiles => this.setAssignedProfiles(profiles));
        this.startInterval();
    }

    private startInterval (): void {
        this.intervalSubscription = interval(this.INTERVAL_TIME)
            .subscribe(() => {
                this.getAssignedProfiles()
                    .then(profiles => this.setAssignedProfiles(profiles));
            });
    }

    private getAssignedProfiles (): Promise<PagePerformanceAssignedProfile[]> {
        const params = {
            page_size: 1,
            page: 1,
        };
        return this.assignedProfilesRepoService.getAll(params, contextTokens.NO_GLOBAL);
    }
}
